// Function loadWoolLabThemesBlock loads the WoolLabThemesBlock class by dynamically importing the js on demand if needed

export function loadWoolLabThemesBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-fabric-swatch-favourites-block-chunk" */ '../widgets/woolLabThemesBlock').then(wg => {

		const { WoolLabThemesBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="WoolLabThemesBlock"]');

		if(!$wg) {
			// console.info('WoolLabThemesBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="WoolLabThemesBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new WoolLabThemesBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new WoolLabThemesBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the WoolLabThemesBlock widget');

}
